import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useApolloClient } from '@apollo/react-hooks';
import { readSettingFile, writeSettingFile } from 'shared/Settings';

export default function SettingMy(props) {
  if (props && !props.onClose) {
    console.warn('Set onClose callback function.');
  }

  const history = useHistory();
  const client = useApolloClient(); // Apollo 캐시 리셋용

  const settings = readSettingFile() || {};

  const [checkedAutoPrint, checkedAutoPrintSet] = useState(settings.autoPrint ?? false);
  const [checkedAutoAccept, checkedAutoAcceptSet] = useState(settings.autoAccept ?? false);
  const [checkedAutoLogin, checkedAutoLoginSet] = useState(settings.autoLogin ?? false);

  const saveSettings = () => {
    const newSettings = {
      ...settings,
      autoPrint: checkedAutoPrint,
      autoAccept: checkedAutoAccept,
      autoLogin: checkedAutoLogin,
    };
    writeSettingFile(newSettings);
    return newSettings;
  };

  /**
   * 로그아웃 처리 함수
   */
  const handleLogout = async () => {
    if (!window.confirm('로그아웃 하시겠습니까?')) return;

    try {
      // 1. 자동로그인 설정을 false로 변경 및 저장
      const currentSettings = readSettingFile() || {};
      currentSettings.autoLogin = false;
      writeSettingFile(currentSettings);

      // 2. 인증 토큰 및 로컬 스토리지 정보 제거
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('ownerId');
      window.sessionStorage.clear();

      // 3. Apollo 클라이언트 캐시 초기화
      if (client) {
        await client.clearStore();
      }

      // 4. 모달이 열려있다면 닫기
      if (props.onClose) {
        props.onClose();
      }

      // 5. 로그인 페이지로 이동 (뒤로가기로 돌아오지 못하도록 replace 사용)
      history.replace('/login');
    } catch (error) {
      console.error('로그아웃 처리 중 오류 발생:', error);
      history.replace('/login');
    }
  };

  return (
    <div className="flex flex-col bg-cust-gray items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none p-4 md:p-6">
      <div className="w-full max-w-lg md:max-w-xl">
        
        {/* 1. 주문접수시 설정 */}
        <div className="flex flex-col sm:flex-row sm:items-start mb-2">
          <label className="block tracking-wide text-base md:text-lg font-bold w-full sm:w-36 mb-2 sm:mb-0 shrink-0">
            <span>주문접수시</span>
          </label>

          <div className="flex flex-col space-y-3 w-full">
            <label className="inline-flex items-center cursor-pointer select-none">
              <input
                type="checkbox"
                className="form-checkbox mr-2 h-6 w-6 sm:h-7 sm:w-7 text-primary rounded"
                name="cb-auto-print"
                checked={checkedAutoPrint}
                onChange={(e) => checkedAutoPrintSet(e.target.checked)}
              />
              <span className="text-sm sm:text-base md:text-lg text-gray-800">
                주문표 자동 인쇄
              </span>
            </label>

            <label className="inline-flex items-center cursor-pointer select-none">
              <input
                type="checkbox"
                className="form-checkbox mr-2 h-6 w-6 sm:h-7 sm:w-7 text-primary rounded"
                name="cb-auto-accept"
                checked={checkedAutoAccept}
                onChange={(e) => checkedAutoAcceptSet(e.target.checked)}
              />
              <span className="text-sm sm:text-base md:text-lg text-gray-800">
                주문접수상태를 [처리중]으로 자동변경
              </span>
            </label>
          </div>
        </div>

        <div className="border-cust-medium-gray border-b my-4 sm:my-5" />

        {/* 2. 로그인 설정 */}
        <div className="flex flex-col sm:flex-row sm:items-center mb-2">
          <label className="block tracking-wide text-base md:text-lg font-bold w-full sm:w-36 mb-2 sm:mb-0 shrink-0">
            <span>로그인</span>
          </label>

          <div className="w-full">
            <label className="inline-flex items-center cursor-pointer select-none">
              <input
                type="checkbox"
                className="form-checkbox mr-2 h-6 w-6 sm:h-7 sm:w-7 text-primary rounded"
                name="cb-auto-login"
                checked={checkedAutoLogin}
                onChange={(e) => checkedAutoLoginSet(e.target.checked)}
              />
              <span className="text-sm sm:text-base md:text-lg text-gray-800">
                자동 로그인 설정
              </span>
            </label>
          </div>
        </div>

        {/* 3. 하단 버튼 (로그아웃 / 저장) */}
        <div className="flex flex-row justify-between space-x-2 mt-6 md:mt-8">
          <button
            className="w-1/2 h-12 md:h-16 text-gray-700 bg-gray-200 hover:bg-gray-300 transition-all font-bold text-base md:text-lg rounded"
            type="button"
            onClick={handleLogout}
          >
            로그아웃
          </button>

          <button
            className="w-1/2 h-12 md:h-16 text-white bg-primary hover:bg-opacity-90 transition-all font-bold text-base md:text-lg rounded"
            type="button"
            onClick={() => {
              saveSettings();
              if (props.onClose) props.onClose();
            }}
          >
            저장
          </button>
        </div>

      </div>
    </div>
  );
}